export function setupCurrentLocationButton({
  map,
  button,
  navigatorObj = navigator,
  alertFn = alert,
  consoleObj = console
}) {
  const handleClick = () => {
    if (!navigatorObj.geolocation) {
      alertFn("このブラウザは現在位置の取得に対応していません");
      return;
    }

    navigatorObj.geolocation.getCurrentPosition(
      (position) => {
        map.flyTo({
          center: [position.coords.longitude, position.coords.latitude],
          zoom: 16,
          essential: true
        });
      },
      (error) => {
        consoleObj.error(error);
        alertFn("現在位置を取得できませんでした");
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    );
  };

  button?.addEventListener("click", handleClick);

  return {
    handleClick
  };
}
